import React from 'react';
import {
  FigureFrame,
  Vignette
} from '../css/_styledComponents';
import RevealOnScroll from '../components/RevealOnScroll';

export default function Figure ({
  children, img, caption, style, left, right, reveal, fullWidth, banded, width, maxWidth, oval
}) {
  return (
    <FigureFrame
      {...left && { left: true }}
      {...right && { right: true }}
      {...fullWidth && { fullWidth: true }}
      {...banded && { banded }}
      {...width && { width }}
      {...maxWidth && { maxWidth }}
      {...oval && { oval }}
      style={style}
    >
      {reveal ? (
        <RevealOnScroll
          {...reveal === 'right' && { direction: 'left' }}
          {...reveal === 'left' && { direction: 'right' }}
        >
          <img src={img} alt={caption} />
          {caption && (
            <figcaption>{caption}</figcaption>
          )}
        </RevealOnScroll>
      ) : (
        <>
          <img src={img} alt={caption} />
          {caption && (
            <figcaption>{caption}</figcaption>
          )}
        </>
      )}
      {children}
    </FigureFrame>
  );
}
